import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
// import Link from "@material-ui/core/Link";
const styles = {
  para: {
    fontSize: 16
  },
  imgdiv: {
    textAlign: "center",
    margin: "10px"
  },
  img: {
    borderRadius: "8px",
    border: "1px solid gray",
    width: "80%"
  }
};

const Laser = props => {
  const { classes } = props;
  return (
    <div>
      <Typography variant="h5">Laser Cutter Characterization</Typography>
      <Typography className={classes.para} paragraph>
        <div className={classes.imgdiv}>
          <img className={classes.img} src="./laser/laser.jpg" alt="laser" />
        </div>
      </Typography>

      <Typography variant="h6">Know Your Machine</Typography>
      <Typography className={classes.para} paragraph>
        Machine
      </Typography>

      <Typography variant="h6">RD Works - Software</Typography>
      <Typography className={classes.para} paragraph>
        Machine
      </Typography>

      <Typography variant="h6">Machine Maintenance</Typography>
      <Typography className={classes.para} paragraph>
        Machine
      </Typography>

      <Typography variant="h6">Materials</Typography>
      <Typography className={classes.para} paragraph>
        Machine
      </Typography>

      <Typography variant="h6">Applications</Typography>
      <Typography className={classes.para} paragraph>
        Machine
      </Typography>

      <Typography variant="h6">Engraving</Typography>
      <Typography className={classes.para} paragraph>
        Machine
      </Typography>

      <Typography variant="h6">Kerf</Typography>
      <Typography className={classes.para} paragraph>
        Machine
      </Typography>

      <Typography variant="h5">CAD Tools</Typography>
      <Typography className={classes.para} paragraph>
        Machine
      </Typography>

      <Typography variant="h6">Inkscape</Typography>
      <Typography className={classes.para} paragraph>
        Machine
      </Typography>

      <Typography variant="h6">Rhino</Typography>
      <Typography className={classes.para} paragraph>
        Machine
      </Typography>

      <Typography variant="h6">Fusion 360</Typography>
      <Typography className={classes.para} paragraph>
        Machine
      </Typography>

      <Typography variant="h6">Solidworks</Typography>
      <Typography className={classes.para} paragraph>
        Machine
      </Typography>

      <Typography variant="h5">Press-fit Construction Kit</Typography>
      <Typography variant="h6">1v, 2V Geodesic Dome</Typography>
      <Typography className={classes.para} paragraph>
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./laser/laser_cb_wt.jpg"
            alt="laser"
          />
        </div>
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./laser/dome_cad0.png"
            alt="laser"
          />
        </div>
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./laser/dome_cad1.png"
            alt="laser"
          />
        </div>
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./laser/dome_cad2.png"
            alt="laser"
          />
        </div>
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./laser/2v_dome_wip1.jpg"
            alt="laser"
          />
        </div>
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./laser/2v_dome_wip2.jpg"
            alt="laser"
          />
        </div>

        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./laser/2v_dome_wip3.jpg"
            alt="laser"
          />
        </div>
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./laser/2v_dome_wip4.jpg"
            alt="laser"
          />
        </div>
        <div className={classes.imgdiv}>
          <img className={classes.img} src="./laser/1v_dome.jpg" alt="laser" />
        </div>
        <div className={classes.imgdiv}>
          <img className={classes.img} src="./laser/domes.jpg" alt="laser" />
        </div>
      </Typography>
      <Typography variant="h6">Flatfab - Dog</Typography>
      <Typography className={classes.para} paragraph>
        <div className={classes.imgdiv}>
          <img className={classes.img} src="./laser/dog_cad1.png" alt="laser" />
        </div>
        <div className={classes.imgdiv}>
          <img className={classes.img} src="./laser/dog_cad2.png" alt="laser" />
        </div>
        <div className={classes.imgdiv}>
          <img className={classes.img} src="./laser/dog_cad3.png" alt="laser" />
        </div>
        <div className={classes.imgdiv}>
          <img className={classes.img} src="./laser/dog_cad4.png" alt="laser" />
        </div>
        <div className={classes.imgdiv}>
          <img className={classes.img} src="./laser/dog.jpg" alt="laser" />
        </div>
      </Typography>
      <Typography variant="h5">Misc.</Typography>
      <Typography className={classes.para} paragraph>
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./laser/helmet_model.jpg"
            alt="laser"
          />
        </div>
      </Typography>
    </div>
  );
};

export default withStyles(styles)(Laser);
